import React, { useEffect, useState } from 'react'
import {
  Badge,
  Button,
  Container,
  Grid,
  Paper,
  Skeleton,
  useTheme,
  useMediaQuery // Import useMediaQuery
} from '@mui/material'
import {
  TextBold,
  TextRegular,
  TextSemiBold
} from '../../../commonComponents/TextStyling'
import JobPost from '../../../commonComponents/JobPost'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import serverData from '../../../api/ServerData'
import { logoutUser } from '../../../actions/loginActions'
import {
  colorWithOpacity,
  formatNumber,
  isEmpty
} from '../../../utils/AppHelper'
import appassets from '../../../utils/appassets'
import { ENV } from '../../../ENV'

export default function DashboardRecruiter (props) {
  const [data, setData] = useState(null)
  const theme = useTheme()
  const [worklistData, setWorklistData] = useState([])
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)

  // Check if the screen size is small
  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  useEffect(function () {
    getDashboardData()
    getWorklist()
  }, [])

  function getDashboardData () {
    serverData.getRecruiterDashboardData(
      {},
      result => {
        if (result.status && result.response) {
          const {
            totalSubmissions,
            qualifiedSubmissions,
            notSubmittedToClient,
            adminReview,
            candidatePendingReview,
            totalEarnings,
            amountPaidToRecruiters
          } = result.response
          setData([
            {
              label: 'Your Earnings',
              value: totalEarnings,
              img: appassets.recruiterSignupDollar
            },
            {
              label: 'Total submissions',
              value: totalSubmissions,
              img: appassets.submit
            },
            {
              label: `Total commission paid by us`,
              value: amountPaidToRecruiters,
              img: appassets.recruiterSignupDollar
            },
            {
              label: 'Qualified submissions',
              value: qualifiedSubmissions,
              img: appassets.hire
            },
            {
              label: 'Not submitted to client',
              value: notSubmittedToClient,
              img: appassets.notSubmitted
            },
            {
              label: `${ENV.product_name} review`,
              value: adminReview,
              img: appassets.review
            },
            {
              label: 'Candidate pending review',
              value: candidatePendingReview,
              img: appassets.pending
            }
          ])
        }
      },
      error => {
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  function getWorklist () {
    serverData.worklistData(
      {},
      result => {
        if (result.status) {
          setWorklistData(result.response)
        }
        setLoading(false)
      },
      error => {
        if (error.status === 401) {
          setLoading(false)
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid container>
          <TextBold
            style={{
              fontSize: '24px',
              marginBottom: '8px'
            }}
          >
            Dashboard
          </TextBold>

          <Grid item xs={12}>
            <Grid container>
              {isEmpty(data)
                ? Array.from(Array(6).keys()).map((e, index) => (
                    <Grid item xs={matches ? 12 : 4} key={index}>
                      <Skeleton
                        variant='rounded'
                        height={114}
                        style={{
                          borderRadius: '16px',
                          marginLeft: matches
                            ? 0
                            : index % 3 === 0
                            ? 0
                            : '24px',
                          marginTop: '24px'
                        }}
                      />
                    </Grid>
                  ))
                : data.map((item, index) => (
                    <Grid
                      item
                      xs={matches ? 12 : 4}
                      key={index}
                      style={{
                        paddingLeft: matches ? 0 : index % 3 === 0 ? 0 : '24px',
                        paddingTop: '24px'
                      }}
                    >
                      <Grid
                        container
                        style={{
                          backgroundColor: theme.palette.background.paper,
                          borderRadius: '16px',
                          padding: 24
                        }}
                      >
                        <Grid item xs={10}>
                          <Grid container>
                            <Grid item xs={12}>
                              <TextRegular
                                style={{
                                  color: theme.palette.text.disabled,
                                  fontSize: '16px'
                                }}
                              >
                                {item.label}
                              </TextRegular>
                            </Grid>
                            <Grid item xs={12} style={{}}>
                              <TextBold
                                style={{
                                  fontSize: '28px'
                                }}
                              >
                                {formatNumber(item.value)}
                              </TextBold>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          xs={2}
                          style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '16px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: colorWithOpacity(
                              theme.palette.primary.main,
                              0.1
                            )
                          }}
                        >
                          <img src={item.img} alt={item.img} />
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container>
          <Grid
            item
            xs={matches ? 12 : 6}
            style={{
              display: 'flex',
              marginTop: matches ? '32px' : '64px',
              marginBottom: '24px'
            }}
          >
            <TextBold style={{ fontSize: '16px' }}>
              Jobs in your worklist
            </TextBold>
            <Badge
              badgeContent={worklistData?.length}
              color='primary'
              style={{ left: 10 }}
            />
          </Grid>

          {!matches && (
            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                justifyContent: 'right',
                alignItems: 'flex-end'
              }}
            >
              <Button
                onClick={() => navigate('/recruiter/newsearch')}
                style={{ textTransform: 'none' }}
              >
                Add jobs to your worklist
              </Button>
            </Grid>
          )}

          <Grid item xs={12}>
            <JobPost data={worklistData} loading={loading} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
